module.exports = __webpack_public_path__ + "static/assets/cfcbc182d7fd1a858126aa1d4875aa6a.gif";